// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, appActions, uiActions} from '@/store'
import FaShare from 'react-icons/lib/fa/share-alt'

type Props = {
  setupSharePortfolioForm: () => void,
  showEditModal: (props: ModalProps) => void,
  modifyCustomerUsersPermissions: () => void,
  l: Language,
}

const renderButton = (props: Object) =>
  <button
    className="btn btn-success"
    onClick={() => {
      props.setupSharePortfolioForm()
      props.showEditModal({
        title: 'Share portfolio',
        onConfirm: props.modifyCustomerUsersPermissions,
      })
    }}
  >
    <FaShare />
  </button>

const RawSharePortfolioButton = (props: Props) => renderButton(props)

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, appActions, uiActions]),
)(RawSharePortfolioButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/share-portfolio-button.js